import CityPageTemplate from "../city-template/CityPageTemplate";
import { springfieldConfig } from "./data";

export default function SpringfieldPage() {
  return <CityPageTemplate config={springfieldConfig} />;
}